import { Component, HostBinding, NgZone, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

import { SettingsService } from './core/settings/settings.service';
import { DataService } from './Service/data.service';
import { RefreshService } from './refresh.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    @HostBinding('class.layout-fixed') get isFixed() { return this.settings.getLayoutSetting('isFixed'); }
    @HostBinding('class.aside-collapsed') get isCollapsed() { return this.settings.getLayoutSetting('isCollapsed'); }
    @HostBinding('class.layout-boxed') get isBoxed() { return this.settings.getLayoutSetting('isBoxed'); }
    @HostBinding('class.layout-fs') get useFullLayout() { return this.settings.getLayoutSetting('useFullLayout'); }
    @HostBinding('class.hidden-footer') get hiddenFooter() { return this.settings.getLayoutSetting('hiddenFooter'); }
    @HostBinding('class.layout-h') get horizontal() { return this.settings.getLayoutSetting('horizontal'); }
    @HostBinding('class.aside-float') get isFloat() { return this.settings.getLayoutSetting('isFloat'); }
    @HostBinding('class.offsidebar-open') get offsidebarOpen() { return this.settings.getLayoutSetting('offsidebarOpen'); }
    @HostBinding('class.aside-toggled') get asideToggled() { return this.settings.getLayoutSetting('asideToggled'); }
    @HostBinding('class.aside-collapsed-text') get isCollapsedText() { return this.settings.getLayoutSetting('isCollapsedText'); }

    constructor(public settings: SettingsService, private DataServiceObj: DataService,
                private refreshService: RefreshService,
                private deviceService: DeviceDetectorService,
                private ngZone: NgZone) { }
    ipAddress: any;

    deviceInfo;
  isMobile;
  isTablet;
  isDesktopDevice;

    ngOnInit() {
        // prevent empty links to reload the page
        // console.log('runs everytime');
        this.getIP();
        this.DataServiceObj.refreshTokenIfExpiring();
        // Outside Angular so the tick does not run change detection across the app.
        this.ngZone.runOutsideAngular(() => setInterval(() => this.DataServiceObj.refreshTokenIfExpiring(), 10000));
        document.addEventListener('click', e => {
            const target = e.target as HTMLElement;
            if (target.tagName === 'A' && ['', '#'].indexOf(target.getAttribute('href')) > -1) {
                e.preventDefault();
            }
        });
        this.refreshService.startIntervalRefresh(5); // every 5 min
        // this.refreshService.listenTabVisibility();

        // Fix for Chromium: "Blocked aria-hidden on an element because its descendant retained focus."
        // When a modal starts hiding, blur any currently focused element inside it so aria-hidden doesn't violate accessibility.
        const blurModalFocus = (event: any) => {
            const modal = event && (event.target || event.detail?.target);
            if (document.activeElement instanceof HTMLElement) {
                if (modal && typeof modal.contains === 'function') {
                    if (modal.contains(document.activeElement)) {
                        document.activeElement.blur();
                    }
                } else {
                    document.activeElement.blur();
                }
            }
        };

        document.addEventListener('hide.bs.modal', blurModalFocus, true);
        const jq = (window as any).$;
        if (jq && typeof jq === 'function') {
            jq(document).on('hide.bs.modal', blurModalFocus);
        }
    }
  getIP()
  {
    let location;

    this.DataServiceObj.getLocation().subscribe((res: any) => {
      this.ipAddress = res;
      location = res.isp + ',' + res.city + ',' + res.state_prov + ',' + res.country_name + ',' + res.zipcode;
    // let json={"status":"success","country":"India","countryCode":"IN","region":"MH","regionName":"Maharashtra","city":"Pune","zip":"411006","lat":18.6161,"lon":73.7286,"timezone":"Asia/Kolkata","isp":"Tata Teleservices Maharashtra Ltd","org":"Tata Teleservices (Maharashtra) Ltd","as":"AS17762 Tata Teleservices Maharashtra Ltd","query":"114.143.194.238"};

      this.deviceInfo = this.deviceService.getDeviceInfo();
      this.isMobile = this.deviceService.isMobile();
      this.isTablet = this.deviceService.isTablet();
      this.isDesktopDevice = this.deviceService.isDesktop();
      let deviceType;
      if (this.isMobile == true)
    {
        deviceType = 'Mobile';
    }
      if (this.isTablet == true)
    {
        deviceType = 'Tablet';
    }
      if (this.isDesktopDevice == true)
    {
        deviceType = 'DesktopDevice';
    }
      const obj = {
    ipAddress: res.ip,
    deviceType,
    location,
    browser: this.deviceInfo.browser ,
    os_version: this.deviceInfo.os_version
};
      this.DataServiceObj.setSystemData(JSON.stringify(obj));
});
  }
}
